module.exports = __webpack_public_path__ + "static/media/ilustracion4.8f8cb638.png";